import { clsx } from "clsx";
import styles from "./typography.module.scss";
import TypographyProps from "./@types/TypographyProps";

const Typography = ({
  children,
  tag,
  "data-testid": dataTestId,
  italic,
  ...props
}: TypographyProps) => {
  const { variant, className, ...rest } = props;

  const classNames = clsx(
    styles[`typography-${variant}`],
    italic && styles["font-italic"],
    className || ""
  );

  const Tag = tag ?? "p";

  return (
    <Tag className={classNames} {...rest} data-testid={dataTestId}>
      {children}
    </Tag>
  );
};

export default Typography;
